module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home-carousel"
  }, [(_vm.show_flag) ? _c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "height": "757px"
    },
    on: {
      "change": _vm.imgAnimation
    }
  }, _vm._l((_vm.sliders), function(slider, index) {
    return _c('el-carousel-item', {
      staticClass: "slider-item",
      style: ('background-image:url(' + slider.bg_pic_url + ')')
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-img",
      class: 'item-img' + (index + 1),
      style: ('background-image:url(' + slider.person_pic_url + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "item-desc",
      class: 'item-desc' + (index + 1)
    }, [_c('img', {
      staticClass: "game-logo",
      class: 'game-logo' + (index + 1),
      attrs: {
        "src": slider.logo_pic_url
      }
    }), _vm._v(" "), _c('h1', {
      staticClass: "game-title"
    }, [_vm._v(_vm._s(slider.big_title))]), _vm._v(" "), _c('div', {
      staticClass: "orange-line"
    }), _vm._v(" "), _c('p', {
      staticClass: "game-desc"
    }, [_vm._v(" " + _vm._s(slider.tips))]), _vm._v(" "), _c('a', {
      staticClass: "detail-link",
      attrs: {
        "href": slider.detail_href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('checkDetail')))])])])])
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d50b428a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Carousel.vue
// module id = 392
// module chunks = 1